import { render } from "./PushNotificationModal.vue?vue&type=template&id=e90bcbb4&scoped=true"
import script from "./PushNotificationModal.vue?vue&type=script&lang=js"
export * from "./PushNotificationModal.vue?vue&type=script&lang=js"

import "./PushNotificationModal.vue?vue&type=style&index=0&id=e90bcbb4&scoped=true&lang=css"

import exportComponent from "D:\\MAMP\\htdocs\\electra\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e90bcbb4"]])

export default __exports__